import { Component, inject } from '@angular/core';
import { DokumentService } from './dokument.service';
import { DokumentSearchComponent } from './dokument-search/dokument-search.component';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { DokumentResultComponent } from './dokument-result/dokument-result.component';
import { DokumentDetailComponent } from './dokument-detail/dokument-detail.component';

@Component({
  selector: 'app-dokumenter',
  imports: [
    DokumentDetailComponent,
    DokumentResultComponent,
    DokumentSearchComponent,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
  ],
  templateUrl: './dokumenter.component.html',
  styleUrl: './dokumenter.component.css',
})
export class DokumenterComponent {
  dokService = inject(DokumentService);
  data = this.dokService.datasource.data;
}
